import { WorkInProgressPopupContent } from './WorkInProgressPopupContent';
import { useWorkInProgressPopup } from './use-work-in-progress-popup';

export const WorkInProgressPopup = () => {
  const { isOpen, dismiss, isDismissing } = useWorkInProgressPopup();

  return (
    <WorkInProgressPopupContent
      open={isOpen}
      onDismiss={dismiss}
      isDismissing={isDismissing}
    />
  );
};
